import sum from 'lodash/sum';
import calcMilesPerYear from './calcMilesPerYear';

const calcTotalMilesPerYear = (vehicleSets) => {
  return sum(vehicleSets.map((set) => calcMilesPerYear(set)));
};

export default calcTotalMilesPerYear;
